import {animateInViewport} from "../transition";

var mapsCenters = [];
var map;
var googleMarkers = [];
window.myMarkerClusterer = null;
var infowindow = null;
var mapDefaults = {
	latitude: 59.963934,
	longitude: 10.781839,
	zoom: 15,
};

function createGoogleMap( mapSettings, markers ) {
	if ( !mapSettings.element.length ) {
		return;
	}

	var latitude = mapDefaults.latitude;
	if ( mapSettings.latitude ) {
		latitude = mapSettings.latitude;
	}

	var longitude = mapDefaults.longitude;
	if ( mapSettings.latitude ) {
		longitude = mapSettings.longitude;
	}

	var zoom = mapDefaults.zoom;
	if ( mapSettings.zoom ) {
		zoom = mapSettings.zoom;
	}

	var scrollwheel = false;
	if ( mapSettings.scrollwheel ) {
		scrollwheel = mapSettings.scrollwheel;
	}

	var styles = [
		{
			"featureType": "all",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"saturation": 36,
				},
				{
					"color": "#333333",
				},
				{
					"lightness": 40,
				},
			],
		},
		{
			"featureType": "all",
			"elementType": "labels.text.stroke",
			"stylers": [
				{
					"visibility": "on",
				},
				{
					"color": "#ffffff",
				},
				{
					"lightness": 16,
				},
			],
		},
		{
			"featureType": "all",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off",
				},
				{
					"color": "#93cba4",
				},
			],
		},
		{
			"featureType": "administrative",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#fefefe",
				},
				{
					"lightness": 20,
				},
			],
		},
		{
			"featureType": "administrative",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#fefefe",
				},
				{
					"lightness": 17,
				},
				{
					"weight": 1.2,
				},
			],
		},
		{
			"featureType": "landscape",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#ebf0eb",
				},
				{
					"lightness": 20,
				},
			],
		},
		{
			"featureType": "poi",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#93cba4",
				},
				{
					"lightness": 21,
				},
			],
		},
		{
			"featureType": "poi",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off",
				},
			],
		},
		{
			"featureType": "poi.park",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#c9e5d1",
				},
				{
					"lightness": 21,
				},
			],
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#ffffff",
				},
				{
					"lightness": 17,
				},
			],
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#ffffff",
				},
				{
					"lightness": 29,
				},
				{
					"weight": 0.2,
				},
			],
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#ffffff",
				},
				{
					"lightness": 18,
				},
			],
		},
		{
			"featureType": "road.local",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#ffffff",
				},
				{
					"lightness": 16,
				},
			],
		},
		{
			"featureType": "transit",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#93cba4",
				},
				{
					"lightness": 19,
				},
			],
		},
		{
			"featureType": "transit.station",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"visibility": "on",
				},
				{
					"color": "#93cba4",
				},
			],
		},
		{
			"featureType": "transit.station",
			"elementType": "labels.text",
			"stylers": [
				{
					"visibility": "off",
				},
				{
					"color": "#a19e9e",
				},
			],
		},
		{
			"featureType": "transit.station",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "on",
				},
			],
		},
		{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#d8dfd8",
				},
				{
					"lightness": 17,
				},
			],
		},
	];

	var mapLocation = new google.maps.LatLng( latitude, longitude );
	var mapOptions = {
		zoom: zoom,
		center: mapLocation,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		draggable: true,
		scrollwheel: scrollwheel,
		gestureHandling: 'cooperative',
		mapTypeControl: false,
		mapTypeControlOptions: {
			style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
			position: google.maps.ControlPosition.TOP_CENTER,
		},
		zoomControl: true,
		zoomControlOptions: {
			position: google.maps.ControlPosition.RIGHT_TOP,
		},
		scaleControl: false,
		streetViewControl: true,
		streetViewControlOptions: {
			position: google.maps.ControlPosition.RIGHT_TOP,
		},
		fullscreenControl: true,
	};

	map = new google.maps.Map( mapSettings.element[ 0 ], mapOptions );

	if ( mapSettings.satellite ) {
		map.setMapTypeId( 'satellite' );
	} else {
		var styledMap = new google.maps.StyledMapType( styles, { name: "Styled Map" } );
		map.mapTypes.set( 'map_style', styledMap );
		map.setMapTypeId( 'map_style' );
	}

	var latLonBounds = new google.maps.LatLngBounds();

	infowindow = new google.maps.InfoWindow( {
		content: '...',
		maxWidth: 250,
	} );

	if ( markers ) {
		for ( var markerIndex = 0; markerIndex < markers.length; markerIndex++ ) {
			var markerPosition = new google.maps.LatLng( markers[ markerIndex ].latitude, markers[ markerIndex ].longitude );

			latLonBounds.extend( markerPosition );

			var markerTitle = mapDefaults.title;
			if ( markers[ markerIndex ].title ) {
				markerTitle = markers[ markerIndex ].title;
			}

			var markerImage = new google.maps.MarkerImage( mapDefaults.marker,
				new google.maps.Size( 29, 42 ),
				new google.maps.Point( 0, 0 ),
				new google.maps.Point( 15, 42 ) );
			var activeMarkerImage = new google.maps.MarkerImage( mapDefaults.activeMarker,
				new google.maps.Size( 29, 42 ),
				new google.maps.Point( 0, 0 ),
				new google.maps.Point( 15, 42 ) );
			if ( markers[ markerIndex ].markerImage ) {
				var markerScale = markers[ markerIndex ].markerScale || 1;
				var markerWidth = parseInt( markers[ markerIndex ].markerSize.width );
				var markerHeight = parseInt( markers[ markerIndex ].markerSize.height );
				var markerScaledWidth = markerWidth * markerScale;
				var markerScaledHeight = markerHeight * markerScale;

				markerImage = {
					url: markers[ markerIndex ].markerImage,
					scaledSize: new google.maps.Size( markerScaledWidth, markerScaledHeight ),
				};
				if ( markers[ markerIndex ].markerAnchor ) {
					markerImage.anchor = new google.maps.Point(
						parseInt( markers[ markerIndex ].markerAnchor.x ) * markerScale,
						parseInt( markers[ markerIndex ].markerAnchor.y ) * markerScale,
					);
				}

				activeMarkerImage = {
					url: markers[ markerIndex ].activeMarkerImage,
					scaledSize: new google.maps.Size( markerScaledWidth, markerScaledHeight ),
				};
				if ( markers[ markerIndex ].markerAnchor ) {
					activeMarkerImage.anchor = new google.maps.Point(
						parseInt( markers[ markerIndex ].markerAnchor.x ) * markerScale,
						parseInt( markers[ markerIndex ].markerAnchor.y ) * markerScale,
					);
				}
			}

			var infowWindowContent;
			if ( mapSettings.infoWindows ) {
				var infowWindowContent = '<div class="info-window !pb-4">';
				if ( markers[ markerIndex ].permalink ) {
					infowWindowContent += '<a href="' + markers[ markerIndex ].permalink + '">';
				}
				if ( markers[ markerIndex ].image ) {
					infowWindowContent += '<img src="' + markers[ markerIndex ].image + '" alt="' + markers[ markerIndex ].title + '">';
				}
				if ( markers[ markerIndex ].title ) {
					infowWindowContent += '<div class="h4">' + markers[ markerIndex ].title + '</div>';
				}
				if ( markers[ markerIndex ].subtitle ) {
					infowWindowContent += '<div class="xsmall-text">' + markers[ markerIndex ].subtitle + '</div>';
				}
				if ( markers[ markerIndex ].permalink ) {
					infowWindowContent += '</a>';
				}
				infowWindowContent += '</div>';
			}

			var label = null;
			if ( mapSettings.clusterer ) {
				label = {
					text: (mapSettings.clusterer) ? '1' : '',
					fontSize: '16px',
					color: "white",
				};
			}

			var marker = new google.maps.Marker( {
				title: markerTitle,
				position: markerPosition,
				zIndex: 1,
				html: infowWindowContent,
				map: map,
				id: markers[ markerIndex ].id,
				icon: markerImage,
				myMarker: markerImage,
				myActiveMarker: activeMarkerImage,
			} );

			if ( infowWindowContent ) {
				google.maps.event.addListener( marker, 'click', function() {
					infowindow.setContent( this.html );
					infowindow.open( map, this );
				} );
			}

			googleMarkers.push( marker );
		}
	}

	if ( mapSettings.clusterer ) {
		var clustererImage = new google.maps.MarkerImage( mapDefaults.marker,
			new google.maps.Size( 29, 42 ),
			new google.maps.Point( 0, 0 ),
			new google.maps.Point( 15, 42 ) );
		if ( mapSettings.clustererImage ) {
			var clustererScale = mapSettings.clustererScale || 1;
			var clustererWidth = parseInt( mapSettings.clustererSize.width );
			var clustererHeight = parseInt( mapSettings.clustererSize.height );
			var clustererScaledWidth = clustererWidth * clustererScale;
			var clustererScaledHeight = clustererHeight * clustererScale;

			clustererImage = {
				url: mapSettings.clustererImage,
				scaledSize: new google.maps.Size( clustererScaledWidth, clustererScaledHeight ),
			};
			if ( mapSettings.clustererAnchor ) {
				clustererImage.anchor = new google.maps.Point(
					parseInt( mapSettings.clustererAnchor.x ) * clustererScale,
					parseInt( mapSettings.clustererAnchor.y ) * clustererScale,
				);
			}
		}
		myMarkerClusterer = new markerClusterer.MarkerClusterer( {
			map: map,
			markers: googleMarkers,
			algorithm: new markerClusterer.SuperClusterAlgorithm( {
				radius: mapSettings.clustererRadius || 40,
			} ),
			renderer: {
				render: function( o ) {
					var markers = o.markers;
					var position = o._position;
					return new google.maps.Marker( {
						title: markerTitle,
						position: {
							lat: position.lat(),
							lng: position.lng(),
						},
						zIndex: 1,
						map: map,
						icon: clustererImage,
						label: {
							text: (markers.length > 99) ? '99+' : '' + markers.length,
							fontSize: '16px',
							color: "white", // fontFamily, fontWeight
						},
					} );
				},
			},
		} );
	}

	if ( markers.length > 1 ) {
		map.fitBounds( latLonBounds );
	} else if ( markers.length ) {
		map.setCenter( new google.maps.LatLng( markers[ 0 ].latitude, markers[ 0 ].longitude ) );
	}

	// Center the map when resizing the window
	google.maps.event.addDomListener( window, 'resize', function() {
		map.setCenter( mapLocation );
		if ( markers.length > 1 ) {
			map.fitBounds( latLonBounds );
		} else if ( markers.length ) {
			map.setCenter( new google.maps.LatLng( markers[ 0 ].latitude, markers[ 0 ].longitude ) );
		}
	} );

	google.maps.event.addListener( map, 'idle', updateClinicCards );
	google.maps.event.addListener( map, 'bounds_changed', updateClinicCards );

	function updateClinicCards() {
		if ( myMarkerClusterer ) {
			for ( const marker of myMarkerClusterer.markers ) {
				// $( '#' + marker.id ).toggle( map.getBounds().contains( marker.getPosition() ) );
				const markerVisibleOnMap = marker.visible && map.getBounds().contains( marker.getPosition() );
				$( '#' + marker.id ).toggleClass( 'hidden', !markerVisibleOnMap );
			}
			animateInViewport();
		}
	}
}

function showStreetview( element, streetviewSettings ) {
	var povPitch = 50;
	if ( streetviewSettings.pitch ) {
		povPitch = streetviewSettings.pitch;
	}

	var povHeading = 120;
	if ( streetviewSettings.heading ) {
		povHeading = streetviewSettings.heading;
	}

	var panoramaOptions = {
		position: new google.maps.LatLng( streetviewSettings.latitude, streetviewSettings.longitude ),
		draggable: false,
		scrollwheel: false,
		pov: {
			heading: povHeading,
			pitch: povPitch,
		},
	};
	var panorama = new google.maps.StreetViewPanorama( element[ 0 ], panoramaOptions );
}

export function updateGoogleMapMarkers( ids ) {
	const latLonBounds = new google.maps.LatLngBounds();
	const visibleMarkers = [];
	for ( const marker of googleMarkers ) {
		if ( ids === 42 || ids.indexOf( marker.id ) > -1 ) {
			marker.setVisible( true );
			visibleMarkers.push( marker );
			latLonBounds.extend( marker.position );
		} else {
			marker.setVisible( false );
		}
	}

	if ( myMarkerClusterer ) {
		myMarkerClusterer.clearMarkers( true );
		myMarkerClusterer.addMarkers( visibleMarkers );
	}

	if ( visibleMarkers.length > 0 ) {
		map.fitBounds( latLonBounds );
	}
}

export function updateGoogleMapMarkersIcon( ids ) {
	for ( const marker of googleMarkers ) {
		if ( ids.indexOf( marker.id ) > -1 ) {
			marker.setIcon( marker.myActiveMarker );
		} else {
			marker.setIcon( marker.myMarker );
		}
	}
}

window.createGoogleMap = createGoogleMap;
window.updateGoogleMapMarkersIcon = updateGoogleMapMarkersIcon;
